"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _typography = require("@berlitz/globals/lib/components/typography");
var _spacer = _interopRequireDefault(require("@berlitz/spacer"));
var _InformationCircle = _interopRequireDefault(require("@berlitz/streamline-icons/lib/bold/01-Interface-Essential/14-Alerts/InformationCircle"));
var _htmlCheck = _interopRequireDefault(require("@berlitz/max-utils/lib/htmlCheck"));
var _style = require("./style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var getBarPercentage = function getBarPercentage(index, arrayLength) {
  return index / arrayLength;
};
var LevelChartComponent = function LevelChartComponent(_ref) {
  var currentLevel = _ref.currentLevel,
    lockedLevel = _ref.lockedLevel,
    chartHelperLabel = _ref.chartHelperLabel,
    groupData = _ref.groupData,
    setActiveLevel = _ref.setActiveLevel,
    tabs = _ref.tabs;
  var activeLevelTabRef = (0, _react.useRef)(null);
  var scrollContainerRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (!activeLevelTabRef.current) return;
    scrollContainerRef.current.scrollLeft = activeLevelTabRef.current.offsetLeft;
  }, []);
  return /*#__PURE__*/_react.default.createElement(_style.Wrapper, {
    "data-key": "max-level-chart"
  }, /*#__PURE__*/_react.default.createElement(_style.ContentWrap, null, tabs.map(function (tab) {
    return currentLevel === tab.level && /*#__PURE__*/_react.default.createElement(_style.Content, {
      "data-key": "max-level-chart__content-".concat(tab.level),
      key: "max-level-chart__content-".concat(tab.level),
      id: "max-level-chart__tab-".concat(tab.level)
    }, /*#__PURE__*/_react.default.createElement(_style.TitleBg, {
      "data-key": "max-level-chart__content__title"
    }, /*#__PURE__*/_react.default.createElement(_style.StyledH3, {
      disableMargin: true,
      inverse: true
    }, tab.groupName)), /*#__PURE__*/_react.default.createElement(_spacer.default, {
      size: "md",
      breakpoints: {
        md: 'lg'
      }
    }), /*#__PURE__*/_react.default.createElement(_style.StyledH3, {
      disableMargin: true
    }, tab.customLevelTitle ? tab.customLevelTitle : "Level ".concat(tab.level)), /*#__PURE__*/_react.default.createElement(_spacer.default, null), _htmlCheck.default.test(tab.content) ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_typography.RichText, {
      dangerouslySetInnerHTML: {
        __html: tab.content
      }
    }), /*#__PURE__*/_react.default.createElement(_spacer.default, {
      size: "lg"
    })) : /*#__PURE__*/_react.default.createElement(_typography.P, null, tab.content));
  })), /*#__PURE__*/_react.default.createElement(_style.Chart, {
    "data-key": "max-level-chart__chart"
  }, !lockedLevel && chartHelperLabel && /*#__PURE__*/_react.default.createElement(_style.ChartHelper, {
    size: "sm"
  }, /*#__PURE__*/_react.default.createElement(_spacer.default, {
    right: true,
    size: "xs"
  }, /*#__PURE__*/_react.default.createElement(_InformationCircle.default, null)), chartHelperLabel), /*#__PURE__*/_react.default.createElement(_style.ChartWrap, {
    ref: scrollContainerRef
  }, groupData.map(function (group, index) {
    return /*#__PURE__*/_react.default.createElement(_style.ChartItems, {
      key: "max-level-chart__chart__group-".concat(index)
    }, /*#__PURE__*/_react.default.createElement(_style.LevelGroup, {
      "data-key": "max-level-chart__chart__lvl"
    }, /*#__PURE__*/_react.default.createElement(_style.LevelGroupTitle, {
      "data-key": "max-level-chart__chart__lvl-".concat(index, "__title")
    }, group.title), /*#__PURE__*/_react.default.createElement(_style.BarGroup, {
      "data-key": "max-level-chart__chart__lvl-".concat(index, "__bars")
    }, group.tabs.map(function (tab) {
      return /*#__PURE__*/_react.default.createElement(_style.BarButton, {
        "data-key": "max-level-chart__chart__lvl-".concat(index, "__bars__toggle"),
        key: tab.level,
        href: "#max-level-chart__tab-".concat(tab.level),
        onClick: function onClick(event) {
          event.preventDefault();
          setActiveLevel(tab.level);
        },
        ref: lockedLevel === tab.level ? activeLevelTabRef : null,
        lockedLevel: lockedLevel === null ? false : true
      }, /*#__PURE__*/_react.default.createElement(_style.Bar, {
        isActive: currentLevel === tab.level,
        size: getBarPercentage(tab.level, tabs.length),
        level: tab.level
      }, /*#__PURE__*/_react.default.createElement(_style.Level, {
        isActive: currentLevel === tab.level,
        level: tab.level
      }, tab.level)));
    }))), groupData.length - 1 !== index && /*#__PURE__*/_react.default.createElement(_spacer.default, {
      size: "lg",
      breakpoints: {
        md: 'sm'
      }
    }));
  }))));
};
var _default = LevelChartComponent;
exports.default = _default;